import {
  companyAchPath,
  companyBacsFlowPath,
  companyPadFlowPath,
  companySepaPath,
} from "@oysterhr/router"
import { Badge, Button, Heading, Icon, Text } from "@oysterhr/ui"
import { useAccountAspect } from "@oysterhr/identity/AccountAspectContext"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { CompanyCurrencyEnumType, Maybe } from "@oysterhr/schema"
import { PaymentMethodCategoryEnumType } from "../../enums"

interface AddPaymentMethodProps {
  paymentMethodType: PaymentMethodCategoryEnumType
  paymentCurrencyCode: Maybe<string> | undefined
}

export const AddPaymentMethod = ({
  paymentMethodType,
  paymentCurrencyCode,
}: AddPaymentMethodProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage", {
    keyPrefix: "addPaymentMethod",
  })
  const { accountAspect: companyId } = useAccountAspect()

  const onConnect = () => {
    switch (paymentCurrencyCode) {
      case CompanyCurrencyEnumType.Eur:
        return navigate(companySepaPath(companyId))
      case CompanyCurrencyEnumType.Usd:
        return navigate(companyAchPath(companyId))
      // NOTE: We fallback to old flows for Bacs & Pad
      case CompanyCurrencyEnumType.Gbp:
        return navigate(companyBacsFlowPath(companyId))
      case CompanyCurrencyEnumType.Cad:
        return navigate(companyPadFlowPath(companyId))
      default:
        throw new Error("Unexpected payment currency")
    }
  }

  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-gray-200 p-6 text-center">
      <Heading size="xl">{t(`${paymentMethodType}.title`)}</Heading>
      <Text className="mt-1 text-gray-400" size="small">
        {t(`${paymentMethodType}.content`)}
      </Text>

      <Badge variation="gray" className="mb-3 mt-3">
        <Icon name="WarningOctagon" />
        {t("badge")}
      </Badge>

      <Button variation="outline" onClick={onConnect}>
        {t("btnConnect")}
      </Button>
    </div>
  )
}
